export function smoothScroll(element, targetPosition, duration = 300) {
  const start = element.scrollLeft;
  const distance = targetPosition - start;

  const getNow = () => (window.performance && window.performance.now)
    ? window.performance.now()
    : Date.now();

  const startTime = getNow();

  const animateScroll = () => {
    const currentTime = getNow();
    const elapsedTime = currentTime - startTime;
    if (elapsedTime < duration) {
      element.scrollLeft = start + distance * (elapsedTime / duration);
      requestAnimationFrame(animateScroll);
    } else {
      element.scrollLeft = targetPosition;
    }
  };

  requestAnimationFrame(animateScroll);
}
